import Validator from "./Validator";

export default class JsonChallengeValidator extends Validator {
  constructor() {
    super();
    this.validationRules = {
      type: 'string',
      empty: false,
      mandatory: true
    };
  }
}
